import { isNull, isObject, isUndefined } from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ROLE_ADMIN } from '../utils/constants/roles.js';

function useIsUserAdmin() {
  const user = useSelector((state) => state.auth.user);

  return useMemo(() => {
    // if user is not valid object, return false
    if (!isObject(user) || isNull(user) || isUndefined(user)) {
      return false;
    }

    // check user's array of roles, if one role has name Administrator, user is ADMIN
    return user.roles.some((role) => role.name === ROLE_ADMIN);
  }, [user]);
}

export default useIsUserAdmin;
